import React, { useState, useRef, useEffect } from "react";
import Editor from "../TET/Editor";
import "./style.css";
import { api_v2 } from "../../NewIndex.api";

const WidgetModel2 = ({ initialData = {}, onChange }) => {
  const [imagePreview, setImagePreview] = useState(
    initialData.imagePreview || ""
  );
  const [image, setImage] = useState(initialData.image || "");
  const fileInput = useRef();
  const [htmlContent, setHtmlContent] = useState(initialData.htmlContent || "");
  const [selectedFile, setSelectedFile] = useState(null);
  const [isUploaded, setIsUploaded] = useState(!!initialData.image);
  const [showRemove, setShowRemove] = useState(!!initialData.image);

  useEffect(() => {
    onChange &&
      onChange({
        image: image,
        imagePreview,
        htmlContent,
      });
    // eslint-disable-next-line
  }, [image, imagePreview, htmlContent]);

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      setSelectedFile(file);
      const reader = new FileReader();
      reader.onload = () => {
        setImagePreview(reader.result);
        setShowRemove(false);
        setIsUploaded(false);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleUpload = () => {
    if (selectedFile) {
      api_v2.uploadImage(
        selectedFile,
        (id) => {
          setImage(id);
          setIsUploaded(true);
          setShowRemove(true);
          setSelectedFile(null);
          if (fileInput.current) fileInput.current.value = "";
        },
        (err) => {
          console.warn(err.message);
        }
      );
    }
  };

  const removeImage = () => {
    api_v2.removeImage(image, (res) => {
      if (res.status === 200 && res.ok) {
        setImagePreview("");
        setShowRemove(false);
        setImage("");
        setIsUploaded(false);
        setSelectedFile(null);
        if (fileInput.current) fileInput.current.value = "";
      } else {
        console.warn("Some Error on our side");
      }
    });
  };

  return (
    <div>
      <div
        className="form-group"
        style={{
          display: "flex",
          alignItems: "center",
          gap: "12px",
          marginTop: "0px",
          marginBottom: "8px",
        }}
      >
        <div style={{ fontWeight: "bold", fontSize: "15px" }}>Upload Image</div>
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <input
            type="file"
            className="form-control-file"
            id="imageUpload"
            onChange={handleFileChange}
            ref={fileInput}
            disabled={isUploaded}
          />
          <button
            type="button"
            className="btn btn-success"
            onClick={handleUpload}
            disabled={!selectedFile || isUploaded}
          >
            Upload
          </button>
          <button
            type="button"
            className="btn btn-danger"
            onClick={removeImage}
            disabled={!showRemove || !isUploaded}
            style={{
              display: showRemove && isUploaded ? "inline-block" : "none",
            }}
          >
            Remove
          </button>
        </div>
        {imagePreview && (
          <img
            id="imagePreview"
            className="preview-image"
            src={imagePreview}
            alt="Preview"
            style={{
              marginLeft: "10px",
              maxHeight: "150px",
              maxWidth: "200px",
              borderRadius: "5px",
              boxShadow: "0 0 8px #eee",
            }}
          />
        )}
      </div>
      <div style={{ marginTop: "10px" }}>
        <h3>HTML Content</h3>
        <Editor textState={htmlContent} onTextChange={setHtmlContent} />
      </div>
    </div>
  );
};
export default WidgetModel2;



// WEBPACK FOOTER //
// ./src/mi-app/adminPanel/Content Management/WidgetModel2.js